export const filtersTranslations = {
  filters_predefined_filters: 7553,
  filters_predefined_date: 3853,
  filters_search_placeholder: 7557,
  filters_date_range_to: 7600,
  filters_date_range_from: 7567,
  filters_date_range_date_interval: 3707,
  filters_date_range_date_fixed_period: 3706,
  add_filters_button_title: 7593,
  add_filters_modal_add_button: 7338,
  add_filters_modal_title: 3560,
  remove_filter: 7662,
  filters_error_message: 7608,
  filters_exclude: 7638,
  filters_include: 7639,
  filter_menu_options_desc_exclude: 7693,
  filter_menu_options_desc_exclude_sub: 7691,
  filter_menu_option_include: 7698,
  filter_menu_option_exclude: 7693,
  filter_menu_option_include_sub: 7696,
  filter_menu_option_exclude_sub: 7691,
  filter_summary_exclude: 8034,
  filter_summary_exclude_sub: 8033,
  filters_included: 7643,
  filters_excluded: 7642,
  filters_decimal_range: 7679,
  filters_my_unit: 7714,
  filters_my_location: 7715,
  filters_person: 7767,
  filters_specific_numbers_ranges_title: 7833,
  filters_specific_numbers_ranges_subtitle: 7838,
  filters_contains_word: 7829,
  filters_contains_word_exact: 7837,
  filters_specified_period: 7830,
  filters_not_specified_title: 7832,
  filters_not_specified_subtitle: 7831,
  filters_must_be_withing_range: 7939,
  no_options_found: 7644,
  disclaimer_message: 7960,
  done: 7338,
  show_details: 7640,
  hide_details: 7641,
  clear_filters: 8139,
  filters_checkbox_checked: 7719,
  filters_checkbox_unchecked: 7720,
  cancel: 7904,
  number_or_separator: 7725,
  required_field: 5949
};

export const filterDomainIds = {
  caseType: 100
};

export const endpoint = {
  filterDomains: 'report/filterDomains',
  filterDomainsSpecialReport: (reportId: number) => `report/specialReport/${reportId}/filterDomains`,
  filterDomainsDashboard: (dashboardType: number) => `dashboard/dashboardType/${dashboardType}/filterDomains`,
  filterDomainsBowtie: 'case/bowtie/filterDomains',
  periods: 'search/options/periods',
  defaultPredefDate: (dbFunction: number) => `date/${dbFunction}`,
  predefinedFilters: 'report/predefinedFilters',
  favouriteAdvancedSearchTypes: 'favourite/definition/draft/advanced/types',
  favouriteAdvancedSearchFields: 'favourite/definition/draft/advanced/fields',
  searchFavouriteAdvancedSearchFields: 'favourite/definition/draft/advanced/fields/search',
  filterOptionsFor: (domainId: number) => `favourite/definition/draft/field/${domainId}/options`,
  filterCategoryOptionsFor: (domainId: number) => `favourite/definition/draft/field/${domainId}/categoryOptions`
};
